
import "./terms.css";

export default function Terms() {

    return(
        <div className="terms-container">
            
            <div className="terms-title">Termos de uso - <strong>winners-ai.com</strong></div>
            <div className="terms-updated"><strong>Última atualização:</strong> 15 de janeiro de 2026</div>
            <span className="terms-space"></span>
            <span className="terms-space"></span>

            <div className="terms-topic-text">Bem-vindo à&nbsp;<strong>Winners AI</strong></div>
            <span className="terms-line-space"></span>
            <div className="terms-topic-text">Estes termos de uso regulam o acesso e a utilização da plataforma disponível no site www.winners-ai.com, de titularidade da <strong>Winners Information Technology Ltda</strong>, CNPJ 10.214.659/0001-02, com sede em São Paulo/SP, Brasil.</div>
            <span className="terms-line-space"></span>

            <div className="terms-topic-text">Ao acessar, criar uma conta ou utilizar a plataforma, você declara que leu, compreendeu e concorda integralmente com estes Termos. Caso não concorde, não utilize a plataforma.</div>
            <span className="terms-space"></span>

            <div className="terms-topic-title">1. Quem somos</div>
            <span className="terms-topic-space"></span>

            <div className="terms-topic-text">
            A Winners AI é uma plataforma tecnológica que permite a criação e
            utilização de agentes de inteligência artificial voltados ao primeiro
            atendimento automatizado de pacientes ou clientes de profissionais que
            prestam serviços em áreas específicas, como medicina e estética.
            </div>

            <div className="terms-topic-text">
            A Winners AI não presta serviços médicos, estéticos ou profissionais ao
            consumidor final, atuando exclusivamente como fornecedora de tecnologia
            ao profissional contratante.
            </div>
            <span className="terms-space"></span>
        
            <div className="terms-topic-title">2. Descrição do serviço</div>
            <span className="terms-topic-space"></span>
            
            <div className="terms-topic-text">A plataforma permite que o profissional:</div>

            <span className="terms-line-space"></span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Crie e configure um agente de IA;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Utilize o agente para comunicação automatizada via WhatsApp, por meio de um número específico disponibilizado para essa finalidade;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Defina informações, fluxos e respostas que serão utilizadas pelo agente no primeiro atendimento.</span>
            <span className="terms-topic-space"></span>
            <span className="terms-topic-alert">Obs.: O serviço tem caráter instrumental e tecnológico, não substituindo o atendimento humano, profissional ou especializado.</span>
            <span className="terms-space"></span>

            <div className="terms-topic-title">3. Público-alvo e relação com terceiros</div>
            <span className="terms-topic-space"></span>

            <div className="terms-topic-text">O cliente direto da Winners AI é o profissional contratante.</div>

            <div className="terms-topic-text">
            Os pacientes ou clientes atendidos pelo agente de IA não mantêm
            qualquer vínculo contratual com a Winners AI, sendo de responsabilidade
            exclusiva do profissional:
            </div>
            
            <span className="terms-line-space"></span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;O conteúdo das mensagens e as informações fornacidas de acordo aos parâmetros cadastrados na plataforma pelo contratante;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;O atendimento posterior ao primeiro contato automatizado.</span>
            <span className="terms-space"></span>
            
            <div className="terms-topic-title">4. Cadastro e conta do usuário</div>
            <span className="terms-topic-space"></span>

            <div className="terms-topic-text">Para utilizar a plataforma, é necessário criar uma conta mediante fornecimento de informações básicas e profissionais.</div>

            <div className="terms-topic-text">O usuário declara que:</div>
            
            <span className="terms-line-space"></span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;As informações fornecidas são verdadeiras, completas e atualizadas;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;É o único responsável pelos dados, conteúdos e configurações inseridas no agente;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Utilizará a plataforma de boa-fé e em conformidade com a legislação vigente.</span>
            
            <span className="terms-topic-space"></span>
            <div className="terms-topic-text">A Winners AI poderá suspender ou excluir contas, a seu exclusivo critério, em casos de:</div>

            <span className="terms-line-space"></span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Uso indevido da plataforma;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Má-fé, fraude ou tentativa de burlar sistemas;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Violação destes Termos ou da legislação aplicável.</span>
            <span className="terms-space"></span>
        
            <div className="terms-topic-title">5. Uso de inteligência artificial</div>
            <span className="terms-topic-space"></span>

            <div className="terms-topic-text">O usuário declara estar ciente de que:</div>

            <span className="terms-line-space"></span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;O agente utiliza inteligência artificial, podendo gerar respostas automatizadas;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;As respostas dependem diretamente das informações fornecidas e configuradas pelo profissional;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;A Winners AI não garante a total precisão, integralidade ou adequação das respostas geradas.</span>
            
            <span className="terms-topic-space"></span>
            <div className="terms-topic-text">O profissional é integralmente responsável por:</div>
            
            <span className="terms-line-space"></span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Revisar e validar os fluxos do agente;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Garantir que o agente não realize diagnósticos, prescrições ou orientações proibidas;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Assegurar o uso ético, legal e adequado da tecnologia.</span>
            <span className="terms-space"></span>

            <div className="terms-topic-title">6. Limitações de responsabilidade</div>
            <span className="terms-topic-space"></span>

            <div className="terms-topic-text">A Winners AI não:</div>
            
            <span className="terms-line-space"></span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Realiza diagnósticos médicos ou de qualquer outra natureza;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Prescreve medicamentos ou tratamentos;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Substitui atendimento profissional humano;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Garante disponibilidade de horários, agendas ou comparecimento de pacientes;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Se responsabiliza por informações inseridas por terceiros.</span>
            
            <span className="terms-topic-space"></span>
            <div className="terms-topic-text">A plataforma atua exclusivamente como meio tecnológico de intermediação e automação de processos iniciais.</div>
            <span className="terms-space"></span>
        
            <div className="terms-topic-title">7. Serviços de terceiros</div>
            <span className="terms-topic-space"></span>

            <div className="terms-topic-text">O funcionamento da plataforma pode depender de serviços de terceiros, incluindo, mas não se limitando a WhatsApp/Meta.</div>

            <div className="terms-topic-text">A Winners AI não se responsabiliza por:</div>
            
            <span className="terms-line-space"></span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Instabilidades, interrupções ou falhas desses serviços;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Mudanças de políticas, regras ou limitações impostas por terceiros;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Bloqueios ou restrições decorrentes do uso dessas plataformas externas.</span>
            <span className="terms-space"></span>

            <div className="terms-topic-title">8. Planos, teste gratuito e pagamentos</div>
            <span className="terms-topic-space"></span>

            <div className="terms-topic-text">A Winners AI opera sob o regime de assinatura mensal.</div>

            <span className="terms-topic-space"></span>
            <div className="terms-topic-subtitle">8.1 Teste gratuito</div>

            <span className="terms-line-space"></span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;O usuário poderá testar a plataforma por 7 (sete) dias, sem custo;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Caso não haja contratação ao final do período, o agente será excluído automaticamente;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Os dados e configurações excluídos não poderão ser recuperados;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Não haverá qualquer ônus ao usuário.</span>
            
            <span className="terms-topic-space"></span>
            <div className="terms-topic-subtitle">8.2 Assinatura e cancelamento</div>
            
            <span className="terms-line-space"></span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;A assinatura é cobrada de forma antecipada, com validade de 30 dias;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;O cancelamento pode ser realizado a qualquer momento;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;O cancelamento impede cobranças futuras, mas não gera reembolso de valores já pagos;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;O agente permanecerá ativo até o fim do período contratado.</span>
            <span className="terms-space"></span>

            <div className="terms-topic-title">9. Propriedade intelectual</div>
            <span className="terms-topic-space"></span>

            <div className="terms-topic-text">Todos os direitos sobre:</div>

            <span className="terms-line-space"></span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Marca Winners AI;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Plataforma, sistemas, código, layout e funcionalidades;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Textos, materiais e conteúdos institucionais;</span>
            
            <span className="terms-topic-space"></span>
            <div className="terms-topic-text">pertencem exclusivamente à Winners Information Technology Ltda.</div>

            <div className="terms-topic-text">É vedado ao usuário copiar, reproduzir, distribuir, modificar ou explorar qualquer parte da plataforma sem autorização expressa.</div>
            <span className="terms-space"></span>

            <div className="terms-topic-title">10. Proteção de dados pessoais</div>
            <span className="terms-topic-space"></span>

            <div className="terms-topic-text">A Winners AI coleta e trata dados pessoais necessários à execução do serviço, incluindo:</div>

            <span className="terms-line-space"></span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Nome da empresa e do profissional;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;CPF ou CNPJ;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;E-mail e telefone;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Dados profissionais e de faturamento.</span>
            
            <span className="terms-topic-space"></span>
            <div className="terms-topic-text">Os dados são armazenados e tratados de forma segura, em conformidade com a Lei Geral de Proteção de Dados (LGPD).</div>

            <div className="terms-topic-text">Uma Política de Privacidade específica poderá ser disponibilizada futuramente, complementando estes Termos.</div>
            <span className="terms-space"></span>

            <div className="terms-topic-title">11. Suspensão e encerramento do serviço</div>
            <span className="terms-topic-space"></span>

            <div className="terms-topic-text">A Winners AI poderá, a qualquer momento:</div>

            <span className="terms-line-space"></span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Suspender o acesso à plataforma;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Encerrar contas;</span>
            <span className="terms-topic-text">&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Excluir agentes;</span>
            
            <span className="terms-topic-space"></span>
            <div className="terms-topic-text">quando identificar violação destes Termos, uso irregular ou risco legal à plataforma.</div>
            <span className="terms-space"></span>

            <div className="terms-topic-title">12. Legislação e foro</div>
            <span className="terms-topic-space"></span>

            <div className="terms-topic-text">Estes Termos são regidos pelas leis da República Federativa do Brasil.</div>

            <div className="terms-topic-text">
            Fica eleito o foro da Comarca de São Paulo/SP, com renúncia a qualquer
            outro, por mais privilegiado que seja, para dirimir eventuais
            controvérsias.
            </div>
        
            <div className="terms-topic-text">Se tiver qualquer dúvida sobre estes Termos, entre em contato pelos canais oficiais da Winners AI.</div>

            <span className="terms-space"></span>
            <span className="terms-space"></span>

        </div>
    )
}